import script from "./IssuesWidget.vue?vue&type=script&lang=ts&setup=true"
export * from "./IssuesWidget.vue?vue&type=script&lang=ts&setup=true"

const __exports__ = script;

export default __exports__